/**
 * @author Gananath Athukorala
 * @version 0.1
 * @since 6/23/2023
 */
import React, { useEffect, useState } from "react";

import api from "../../../../base/services/ResApi";
import { RequestErrorHandeling } from "../../../../base/errorHandeling/RequestErrorHandeling";
import OrgsFormModal from "./OrgsFormModal";
import buildings from "../../../../../resources/buildings.png";

const EditOrgsModal = ({
  open,
  onClose,
  roleData,
  existingCode,
  setUpdateData,
  orgLogo,
}) => {
  const [data, setData] = useState([])
  const [updatedValues, setUpdatedValues] = useState({ orgCode: existingCode })
  const [isLoading, setIsLoading] = useState(false)
  const [isBtnLoading, setIsBtnLoading] = useState(false)

  const [profilePic, setProfilePic] = useState(buildings)

  //for success messages
  const [isSuccess, setIsSuccess] = useState(false)
  const [successMessages, setSuccessMessages] = useState([])

  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  // Contact validations
  const [isPrimContactValid, setIsPrimContactValid] = useState(false)
  const [primErrorMessage, setPrimErrorMessage] = useState()
  const [isSecContactValid, setIsSecContactValid] = useState(false)
  const [secErrorMessage, setSecErrorMessage] = useState()

  useEffect(() => {
    setData(roleData)
  }, [roleData])

  const handleClear = () => {
    setPrimErrorMessage()
    setIsPrimContactValid(false)
    setSecErrorMessage()
    setIsSecContactValid(false)
    
    setTimeout(() => {
      onClose()
      setIsSuccess(false)
      setSuccessMessages([""])
      setIserror(false)
      setErrorMessages([])
      setUpdateData(true)
      setIsBtnLoading(false)
    }, 3000)
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    setIsBtnLoading(true)
    setPrimErrorMessage()
    setIsPrimContactValid(false)
    setSecErrorMessage()
    setIsSecContactValid(false)

    const primContact = data.primContact
    const secContact = data.secContact

    if (primContact && (primContact.length < 10 || primContact.length > 20)) {
      setPrimErrorMessage(
        "Primary contact should be between 10 and 20 characters."
      )
      setIsPrimContactValid(true)
      setIsBtnLoading(false)
    } else if (
      secContact &&
      (secContact.length < 10 || secContact.length > 20)
    ) {
      setSecErrorMessage(
        "Secondary contact should be between 10 and 20 characters."
      )
      setIsSecContactValid(true)
      setIsBtnLoading(false)
    } else if (primContact && primContact === secContact) {
      setPrimErrorMessage("Primary and secondary contacts should not be equal.")
      setSecErrorMessage("Primary and secondary contacts should not be equal.")
      setIsPrimContactValid(true)
      setIsSecContactValid(true)
      setIsBtnLoading(false)
    } else {
      handleEditOrg()
    }
  }

  const handleEditOrg = () => {
    let postConfig = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
    const updatedOrg = new Blob([JSON.stringify(updatedValues)], {
      type: "application/json",
    })
    const formData = new FormData()
    formData.append("updated_org_details", updatedOrg)
    formData.append("updated_org_logo", profilePic)

    api
      .put("/organizations", formData, postConfig)
      .then((res) => {
        setIsLoading(false)
        setErrorMessages([])
        setIserror(false)
        setErrorMessages([])
        setIsSuccess(true)
        setSuccessMessages([res.data?.description])
        handleClear()
      })
      .catch((error) => {
        setIsBtnLoading(false)
        setIsLoading(false)
        setIsSuccess(false)
        RequestErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow
        )
        handleClear()
      })
  }

  return (
    <OrgsFormModal
      open={open}
      data={data}
      setData={setData}
      updatedValues={updatedValues}
      setUpdatedValues={setUpdatedValues}
      isSuccess={isSuccess}
      successMessages={successMessages}
      iserrorShow={iserrorShow}
      iserror={iserror}
      setIserror={setIserror}
      errorMessages={errorMessages}
      setErrorMessages={setErrorMessages}
      isLoading={isLoading}
      handleSubmit={handleSubmit}
      isPrimContactValid={isPrimContactValid}
      primErrorMessage={primErrorMessage}
      isSecContactValid={isSecContactValid}
      secErrorMessage={secErrorMessage}
      handleClear={handleClear}
      isBtnLoading={isBtnLoading}
      title="Update Organization"
      orgNameDisabled={false}
      setProfilePic={setProfilePic}
      profilePic={profilePic}
      orgLogo={orgLogo}
      onClose={onClose}
    />
  )
}

export default EditOrgsModal;
